//Dashboards
Vue.component('dashboard-widget-filter', require('./admin//dashboards/dashboardWidgetFilter.vue'));
Vue.component('dashboard-widget', require('./admin/dashboards/dashboardWidget.vue'));
Vue.component('dashboard-widget-object', require('./admin/dashboards/dashboardWidgetObject.vue'));
Vue.component('dashboard-main-filter', require('./admin/dashboards/dashboardMainFilter.vue'));
Vue.component('dashboard', require('./admin/dashboards/dashboard.vue'));
Vue.component('comments-manager', require('./admin/commentsManager.vue'))
Vue.component('notifications-counter', require('./admin/NotificationCounter.vue'))
Vue.component('notification-center', require('./admin/notificationCenter.vue'))
Vue.component('notification', require('./admin/NotificationItem.vue'))
Vue.component('dashboard-menu', require('./admin/dashboardMenu.vue'))
Vue.component('dashboard-menu-item', require('./admin/dashboardMenuItem.vue'))



// WEBPACK FOOTER //
// ./resources/js/components/vue-declarator.js